<template>
  <div class="search-bar">
    <div class="search">
      <input class="input" v-model="keyword" placeholder="请输入关键词搜索" type="text" />
      <i @click="search" class="el-icon-search search-ico"></i>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      keyword: ''
    }
  },
  methods: {
    search () {
      this.$emit('search', this.keyword)
    },
    getStr (str) {
      this.keyword = str
    }
  }
}
</script>

<style lang="scss" scoped>
.search-bar {
  height: 128px;
  background: rgba(69, 122, 227, 0.3);
  overflow: hidden;
  .search {
    position: relative;
    width: 720px;
    height: 48px;
    margin: 40px auto;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    .input {
      height: 100%;
      width: 660px;
      padding-left: 20px;
      border: none;
      outline: none;
      &::-webkit-input-placeholder {
        color: #c7c7c7;
      }
      &::-moz-input-placeholder {
        color: #c7c7c7;
      }
      &::-ms-input-placeholder {
        color: #c7c7c7;
      }
    }
    .search-ico {
      position: absolute;
      top: 6px;
      right: 4px;
      padding: 6px;
      font-size: 24px;
      color: #c7c7c7;
      cursor: pointer;
    }
  }
}
</style>
